var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('InvitationForm'),_c('section',{staticClass:"search"},[_c('div',{staticClass:"ns-container"},[_c('div',{staticClass:"row"},[_c('TableServer',{attrs:{"options":_vm.options}})],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }